import './App.css'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AuthLayout from './components/layouts/AuthLayout';
import Ideas from './components/Ideas/Ideas';
import IdeaDetails from './components/Ideas/IdeaDetails/IdeaDetails';
import Users from './components/Users/Users';
import Settings from './components/Settings/Settings';
import Tags from './components/Tags/Tags';
import ProtectedRoute from './components/layouts/ProtectedRoute';
import Events from './components/Events/Events';
import EventEditForm from './components/Events/EventEditForm/EventEditForm';
import PublicEventsList from './components/Events/PublicEventsList/PublicEventsList';
import PublicEventDetail from './components/Events/PublicEventDetail/PublicEventDetail';
import VerifyEmail from './components/VerifyEmail/VerifyEmail';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<AuthLayout />} />

          <Route path="/events" element={<PublicEventsList />} />
          <Route path="/events/:id" element={<PublicEventDetail />} />
          <Route path="/verify-email" element={<VerifyEmail />} />

          <Route path="/crm" element={<ProtectedRoute />}>
            <Route index path="ideas" element={<Ideas />} />
            <Route path="ideas/:id" element={<IdeaDetails />} />
            <Route path="users" element={<Users />} />
            <Route path="tags" element={<Tags />} />
            <Route path="settings" element={<Settings />} />
            <Route path="events" element={<Events />} />
            <Route path="events/:id" element={<EventEditForm />} />
          </Route>
        </Routes>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />
      </div>
    </BrowserRouter>
  )
}

export default App
